// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1nApx","calendarButtons":"ClockData_calendarButtons__276yy"};